import ArrowIcon from "assets/icons/arrow_ios.svg?react";
import moment from "moment";
import { useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useTranslation } from "react-i18next";

const monthsKeys = [
  "calendar.months.january",
  "calendar.months.february",
  "calendar.months.march",
  "calendar.months.april",
  "calendar.months.may",
  "calendar.months.june",
  "calendar.months.july",
  "calendar.months.august",
  "calendar.months.september",
  "calendar.months.october",
  "calendar.months.november",
  "calendar.months.december",
];

const MonthList: FC<Props> = ({ date, handleChangeDate }) => {
  const { t } = useTranslation();
  const [actualDate, setActualDate] = useState(date);

  const handleChangeMonth = (month: number) => {
    const d = moment(actualDate)
      .set("month", month + 1)
      .startOf("month")
      .toDate();
    handleChangeDate(d);
  };

  const handleIncrementYear = () => {
    const newD = moment(actualDate).add(1, "year");
    setActualDate(newD.toDate());
  };

  const handleDecreseYear = () => {
    const newD = moment(actualDate).subtract(1, "year");
    setActualDate(newD.toDate());
  };

  return (
    <div className={styles.monthsWrapper}>
      <div className={styles.actDate}>
        <ArrowIcon onClick={handleDecreseYear} className={`${styles.icon} `} />
        {moment(actualDate).year().toString()}
        <ArrowIcon
          onClick={handleIncrementYear}
          className={`${styles.icon} ${styles.reverse}`}
        />
      </div>
      <div className={styles.monthList}>
        {monthsKeys.map((m, index) => (
          <div
            key={m}
            onClick={() => handleChangeMonth(index)}
            className={`${styles.month} ${
              moment(date).month() === index &&
              moment(date).year() === moment(actualDate).year() &&
              styles.activeMonth
            }`}
          >
            {t(m)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthList;
